<pre class="console-output">{{{text}}}</pre>